// src/redux/sagas/timesheetSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../api";

// adapte si tu as déjà ces helpers chez toi
import { getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    SET_TIMESHEET_LOADING,

    FETCH_TIMESHEETS_REQUEST,
    fetchTimesheetsSuccess,
    fetchTimesheetsFail,

    GET_TIMESHEET_REQUEST,
    getTimesheetSuccess,
    getTimesheetFail,

    CREATE_TIMESHEET_REQUEST,
    createTimesheetSuccess,
    createTimesheetFail,

    UPDATE_TIMESHEET_REQUEST,
    updateTimesheetSuccess,
    updateTimesheetFail,

    DELETE_TIMESHEET_REQUEST,
    deleteTimesheetSuccess,
    deleteTimesheetFail,

    FETCH_TIMESHEET_DAYS_REQUEST,
    fetchTimesheetDaysSuccess,
    fetchTimesheetDaysFail,

    UPSERT_TIMESHEET_DAY_REQUEST,
    upsertTimesheetDaySuccess,
    upsertTimesheetDayFail,

    DELETE_TIMESHEET_DAY_REQUEST,
    deleteTimesheetDaySuccess,
    deleteTimesheetDayFail,

    setTimesheetLoading,
} from "../actions/timesheetActions";

// petite util (même logique que tu utilises ailleurs)
const extractErrorMessage = (error, fallback) => {
    return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback
    );
};

// =========================
// TIMESHEETS
// =========================
export function* fetchTimesheetsSaga() {
    const url = `${API_BASE_URL}/api/timesheets`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchTimesheetsSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchTimesheetsFail(extractErrorMessage(error, "Erreur chargement timesheets")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* getTimesheetSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getTimesheetSuccess(resp.data));
    } catch (error) {
        yield put(getTimesheetFail(extractErrorMessage(error, "Erreur chargement timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* createTimesheetSaga(action) {
    const data = action.payload; // TimesheetSaisieRequestDTO
    const url = `${API_BASE_URL}/api/timesheets`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data, headers: { uid } });
        yield put(createTimesheetSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Période créée",
            timer: 1200,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur gggcréation timesheet");
        yield put(createTimesheetFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* updateTimesheetSaga(action) {
    const { id, payload } = action.payload;
    const data = payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        yield put(updateTimesheetSuccess(resp.data));
    } catch (error) {
        yield put(updateTimesheetFail(extractErrorMessage(error, "Erreur mise à jour timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* deleteTimesheetSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteTimesheetSuccess(id));
    } catch (error) {
        yield put(deleteTimesheetFail(extractErrorMessage(error, "Erreur suppression timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

// =========================
// DAYS
// =========================
export function* fetchTimesheetDaysSaga(action) {
    const timesheetId = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${timesheetId}/days`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchTimesheetDaysSuccess(timesheetId, resp.data || []));
    } catch (error) {
        yield put(fetchTimesheetDaysFail(extractErrorMessage(error, "Erreur chargement jours")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* upsertTimesheetDaySaga(action) {
    const data = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/days`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    // (option) loading soft, sinon tu peux mettre un loading par cellule
    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        yield put(upsertTimesheetDaySuccess(resp.data));
    } catch (error) {
        yield put(upsertTimesheetDayFail(extractErrorMessage(error, "Erreur sauvegarde jour")));
    }
}

export function* deleteTimesheetDaySaga(action) {
    const { dayId, timesheetId } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/days/${dayId}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteTimesheetDaySuccess(dayId, timesheetId));
    } catch (error) {
        yield put(deleteTimesheetDayFail(extractErrorMessage(error, "Erreur suppression jour")));
    }
}

// =========================
// WATCHER
// =========================
